import { render, staticRenderFns } from "./AppPrivacyPolicy.vue?vue&type=template&id=2e69d976&"
import script from "./AppPrivacyPolicy.vue?vue&type=script&lang=js&"
export * from "./AppPrivacyPolicy.vue?vue&type=script&lang=js&"
import style0 from "./AppPrivacyPolicy.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports